import React from 'react'
import { Tab } from 'semantic-ui-react'

import Service from './ServiceByRegion'

export default ({ regions }) => (
  <Tab.Pane attached={false}>
    {
      regions.map(region => (
        <Service region={region} />
      ))
    }
  </Tab.Pane>
)



// WEBPACK FOOTER //
// ./src/containers/configurations/Service/index.js